import React from 'react';

const BereavementContext = React.createContext();

export const BereavementProvider = BereavementContext.Provider;
export const BereavementConsumer = BereavementContext.Consumer;
